// Librairies
import React from 'react';
import { Link } from 'react-router-dom';
// CSS
import style from './ModuleCardActu.css';
import Masonry from 'react-masonry-component';
import * as icones from '../Icones'
import * as tools from '../Tools';
import isExternal from 'is-url-external';

const masonryOptions = {
	transitionDuration: 1
};

const imagesLoadedOptions = { background: '.my-bg-image-el' };






export class ModuleCardActu extends React.Component {


	encart = element => <div
		className={style.moduleEncart}
		style={{ borderRadius: '10px' }}
	>
		<div
			className={style.moduleEncartMtTitre}
			style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px', backgroundColor: tools.getColorOfMediaType(element.mediaChild.mediaType.id) || '#7cb4d7' }}
		>
			{/* *** titre *** */}
			<h4 className="text-center pt-2 ft-lato text-white" style={{fontSize: '1.2rem'}}>
				{element.mediaChild.mediaType.nom}
			</h4>
			{/* ******************** */}

			{/* *** image *** */}
			<div
				className={" " + style.encartContenuImage}
				style={{ position: 'relative' }}
			>
				<div className="align-self-center" style={{ margin: '0 auto' }}>
					{this.icone(element.iconSrc)}
				</div>
				<div
					className={" " + style.encartFleche}
					style={{
						zIndex: '5',
						position: 'absolute',
						marginTop: '-1px',
						borderTop: '15px solid '+ tools.getColorOfMediaType(element.mediaChild.mediaType.id) || '#7cb4d7'
						// borderTop: '15px solid ' + tools.getColorOfMediaType(element.mediaChild.mediaType.id) || '#7cb4d7'
					}}
				/>
				<img
					// src={`${tools.lienPhotos}/${element.imgSrc}`}
					src={`${element.mediaChild.couverture && element.mediaChild.couverture.thumbnail_high.publicLink}`}
					className={"img-fluid " + style.encartImage}
					style={{ filter: 'brightness(100%)', zIndex: '1' }}
				/>
			</div>



		</div>
		{/* ********************** */}
		<div
			// className={style.moduleEncart}
			style={{ border: '0px solid #fff', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', backgroundColor: '#fff' }}
		>
			<div style={{ zIndex: '10' }}>
				<h5
					className="pl-4 pr-4 pt-4 ft-alegreya-sans-medium"
					style={{ color: '#333' }}
				>
					{element.mediaChild.sousTitre}
				</h5>
				<div className="pl-4 pr-4 text-justify">
					<div
						className="ft-alegreya-sans-light pb-3 text-black"
						dangerouslySetInnerHTML={{ __html: element.mediaChild.contenu }}
					/>

					{/* Bloc Lire la suite */}
					{!element.lireLaSuiteHidden && (
						<div
							className="ml-1 ft-lato-light pb-4"
							style={{ color: '#333', fontSize: '1.2em' }}
						>
							<icones.flecheCouleur width={25} couleur={tools.getColorOfMediaType(element.mediaChild.mediaType.id) || '#7cb4d7'} />

							&nbsp;&nbsp;{element.textLink || "Lire la suite"}
						</div>
					)}
					{element.lireLaSuiteHidden && (
						<p className="pb-2"></p>
					)}
					{/* ********************************** */}

				</div>
			</div>
		</div>
	</div>



	icone(nomIcone) {
		return (
			<img
				src={nomIcone}
				style={{
					width: '120px',
					position: 'absolute',
					zIndex: '2',
					top: '50%',
					left: '50%' /* à 50%/50% du parent référent */,
					transform:
						'translate(-50%, -50%)' /* décalage de 50% de sa propre taille */
				}}
			/>
		);
	}


	render() {

		const childElements = this.props.elements.map(element => {
			return (

				<div className={"col-xl-4 col-md-6 mb-3 block"}>
					{isExternal(element.linkTo) ? (
						<a
							href={element.linkTo}
							target="_blank"
							to={element.linkTo}
							style={{ textDecoration: 'none' }}
						>
							{this.encart(element)}
						</a>
					) : (
							<Link
								to={element.linkTo}
								className=""
								style={{ textDecoration: 'none' }}
							>
								{this.encart(element)}
							</Link>
						)}
				</div>

			);
		});

		return (
			<Masonry
				className={'row'} // default ''
				elementType={'div'} // default 'div'
				options={masonryOptions} // default {}
				disableImagesLoaded={false} // default false
				updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
				imagesLoadedOptions={imagesLoadedOptions} // default {}
			>
				{childElements}
			</Masonry>
		);
	}
}

